var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticStyle:{"font-size":"20px","font-weight":"500","text-align":"center","margin-top":"80px"}},[_vm._v(" 暂不支持的配置类型 ")])
}
var staticRenderFns = []

export { render, staticRenderFns }